import React from 'react';
import moment from 'moment';
import _ from 'lodash';

/* Position hour */
const positionHour = valor => {
  let total = 100 * valor;
  total /= 86400;

  return total;
};

const positionHourType = type => {
  if (type === 'start') {
    return '+ 5.5px';
  } else if (type === 'end') {
    return '- 40.5px';
  }
  return '- 18.5px';
};

const positionHourTypeBorder = type => {
  if (type === 'start') {
    return '+ 5.5px';
  } else if (type === 'end') {
    return '- 40.5px';
  }
  return '- 1.5px';
};

const convertHour = (s, format) => {
  moment(s).format('DD MMM YYYY hh:mm a');

  return moment(s)
    .startOf('day')
    .seconds(s)
    .format(format);
};

const arrHours = [
  { type: 'start', value: 0 },
  { type: 'normal', value: 10800 },
  { type: 'normal', value: 21600 },
  { type: 'normal', value: 32400 },
  { type: 'normal', value: 43200 },
  { type: 'normal', value: 54000 },
  { type: 'normal', value: 64800 },
  { type: 'normal', value: 75600 },
  { type: 'end', value: 86399 }
];

const draw = (obj, rowDate) => {
  const date = obj.start.substring(0, 10);
  const rd = rowDate.substring(0, 10);
  const hour = obj.start.substring(11, 19);
  let a = hour.split(':'); // split it at the colons
  let seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];

  let left = positionHour(seconds);
  if (rd > date) {
    left = 0;
  }

  let sum = left + positionHour(obj.duration);
  let width = positionHour(obj.duration);
  if (sum > 100) {
    width = 100 - left;
  }
  return {
    position: 'absolute',
    left: `${left}%`,
    width: `${width}%`,
    height: '5px'
  };
};

const drawStart = (obj, rowDate) => {
  const date = obj.start.substring(0, 10);
  const rd = rowDate.substring(0, 10);
  const hour = obj.start.substring(11, 19);
  let a = hour.split(':'); // split it at the colons
  let seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];

  let left = positionHour(seconds);
  if (rd > date) {
    left = 0;
  }

  let sum = left + positionHour(obj.duration);
  let width = positionHour(obj.duration);
  if (sum > 100) {
    width = 100 - left;
  }
  return {
    position: 'absolute',
    left: `calc(${left}% - 7px)`
  };
};

const drawEnd = (obj, rowDate, point) => {
  const date = obj.start.substring(0, 10);
  const rd = rowDate.substring(0, 10);
  const hour = obj.start.substring(11, 19);
  let a = hour.split(':'); // split it at the colons
  let seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];

  let left = positionHour(seconds);
  if (rd > date) {
    left = 0;
  }

  let sum = left + positionHour(obj.duration);
  let width = positionHour(obj.duration);
  if (sum > 100) {
    width = 100 - left;
  }
  let pix = '6';
  if (point) {
    pix = '-1';
  }
  return {
    position: 'absolute',
    left: `calc(${left}% + ${width}% - ${pix}px)`
  };
};

const nfaText = nfa => {
  if (nfa.toString() === '1') {
    return (
      <p className="green">NFA1: 0% A 2% de sufrir un evento de somnolencia en su próxima jornada (Riesgo bajo)</p>
    );
  } else if (nfa.toString() === '2') {
    return (
      <p className="yellow">
        NFA2: 2% A 10% de sufrir un evento de somnolencia en su próxima jornada (Riesgo Medio){' '}
      </p>
    );
  } else if (nfa.toString() === '3') {
    return (
      <p className="orange">
        NFA3: 10% A 20% de sufrir un evento de somnolencia en su próxima jornada (Riesgo Medio-Alto)
      </p>
    );
  } else if (nfa.toString() === '4') {
    return (
      <p className="red">NFA4: 20% A 100% de sufrir un evento de somnolencia en su próxima jornada (Riesgo Alto)</p>
    );
  }
};

const TimeLine = props => {
  return (
    <div className="width padding">
      <section className="time-line--title">Jornada</section>
      <section className="time-line">
        <div className="row">
          <div className="block">Día</div>
          <div className="space" />
          <div className="hours">
            {arrHours.map(item => {
              return (
                <div
                  className="line"
                  key={item.value}
                  style={{
                    left: `calc(${positionHour(item.value)}% ${positionHourType(item.type)}`
                  }}
                >
                  {convertHour(item.value, 'HH:mm')}
                </div>
              );
            })}
          </div>
          <div className="space border" />
          <div className="block">Horas</div>
          <div className="block nothing">NFA</div>
        </div>
        {_.orderBy(props.time, ['date'], ['desc']).map((item, i) => (
          <div className="row" key={i}>
            <div className={i % 2 == 0 ? `block darker` : `block white`}>
              {moment(item.date).format('DD-MM')}
            </div>
            <div className={i % 2 == 0 ? `space dark` : `space`} />
            <div className={i % 2 == 0 ? `hours dark` : `hours`}>
              {item.segments.map((line, i) => {
                const date1 = line.start.substring(0, 10);
                const date2 = item.date.substring(0, 10);
                const date3 = line.end.substring(0, 10);

                let num = i - 1;
                let first = item.segments[num];
                if (first) {
                  first = first.type.toLowerCase() === 'shift';
                } else {
                  first = false;
                }
                return (
                  <div key={i}>
                    <span
                      className={
                        date1 === date2
                          ? `${line.type.toLowerCase()} linel`
                          : `${line.type.toLowerCase()} `
                      }
                      style={draw(line, item.date)}
                    >
                      <div className="hover">
                        <ul>
                          <li>
                            <strong>Actividad</strong>: {line.type ? line.type : ''}
                          </li>
                          <li>
                            <strong>Duración</strong>: {line.duration ? line.duration : ''}
                          </li>
                          <li>
                            <strong>Inicio</strong>:{' '}
                            {line.start ? moment(line.start.substring(0, 19)).format('hh:mm') : ''}
                          </li>
                          <li>
                            <strong>Fin</strong>:{' '}
                            {line.end ? moment(line.end.substring(0, 19)).format('hh:mm') : ''}
                          </li>
                          <li>
                            <strong>Lugar</strong>: {line.description ? line.description : ''}
                          </li>
                        </ul>
                      </div>
                    </span>
                    {line.type.toLowerCase() === 'shift' && date1 === date2 && (
                      <span className={`start`} style={drawStart(line, item.date)}>
                        <div className="hover">
                          <ul>
                            <li>
                              <strong>Actividad</strong>: {line.type ? line.type : ''}
                            </li>
                            <li>
                              <strong>Duración</strong>: {line.duration ? line.duration : ''}
                            </li>
                            <li>
                              <strong>Inicio</strong>:{' '}
                              {line.start
                                ? moment(line.start.substring(0, 19)).format('hh:mm')
                                : ''}
                            </li>
                            <li>
                              <strong>Fin</strong>:{' '}
                              {line.end ? moment(line.end.substring(0, 19)).format('hh:mm') : ''}
                            </li>
                            <li>
                              <strong>Lugar</strong>: {line.description ? line.description : ''}
                            </li>
                          </ul>
                        </div>
                      </span>
                    )}
                    {line.type.toLowerCase() === 'shift' && date2 === date3 && (
                      <span className={`start`} style={drawEnd(line, item.date)}>
                        <div className="hover">
                          <ul>
                            <li>
                              <strong>Actividad</strong>: {line.type ? line.type : ''}
                            </li>
                            <li>
                              <strong>Duración</strong>: {line.duration ? line.duration : ''}
                            </li>
                            <li>
                              <strong>Inicio</strong>:{' '}
                              {line.start
                                ? moment(line.start.substring(0, 19)).format('hh:mm')
                                : ''}
                            </li>
                            <li>
                              <strong>Fin</strong>:{' '}
                              {line.end ? moment(line.end.substring(0, 19)).format('hh:mm') : ''}
                            </li>
                            <li>
                              <strong>Lugar</strong>: {line.description ? line.description : ''}
                            </li>
                          </ul>
                        </div>
                      </span>
                    )}

                    {line.type.toLowerCase() === 'shift' && date2 === date3 && (
                      <span
                        className={`nfa nfa-${item.cfl}`}
                        style={drawEnd(line, item.date, 'point')}
                      >
                        {item.cfl}
                        <div className="hover">
                          <p>
                            NFA (En timeline): Indicador que calcula la probabilidad de ocurrencia
                            de al menos un evento de somnolencia en una jornada de trabajo
                            dentro de las próximas 24 horas. Se calcula tomando la información
                            histórica desde el término de la jornada 24x7 horas hacia atrás. Hay 4
                            niveles de fatiga acumulada, clasificados en función de las
                            probabilidades de sufrir un evento de somnolencia:
                          </p>
                          {nfaText(item.cfl)}
                        </div>
                      </span>
                    )}
                  </div>
                );
              })}
              {arrHours.map(item => {
                if (item.type === 'normal') {
                  return (
                    <div
                      className="content line"
                      key={item.value}
                      style={{
                        left: `calc(${positionHour(item.value)}% ${positionHourTypeBorder(
                          item.type
                        )}`
                      }}
                    >
                      <span />
                    </div>
                  );
                }
              })}
            </div>
            <div className={i % 2 == 0 ? `space dark border` : `space border`} />
            <div className={i % 2 == 0 ? `block darker` : `block white`}>
              {convertHour(item.hoursInShift, 'HH[h]:mm[m]')}
            </div>
            <div className={i % 2 == 0 ? `block darker` : `block white`}>
              <span className={`nfa cl-${item.cfl}`}>{item.cfl}</span>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};
export default TimeLine;



// WEBPACK FOOTER //
// ./source/client/components/common/timeLine.jsx